import { Error, InlineStack } from '@shopify/polaris'
import { useCallback, useEffect, useMemo } from 'react'

import { monthOptions } from './helpers'
import { MemoedNumericSelect, numericRangeOptions } from './NumericSelect'

const getDaysInMonth = (month: number): number => {
  // INFO: Use 2024 (a leap year) to allow Feb 29 as a valid date
  // INFO: This ensures recurring dates work correctly for leap year dates
  return new Date(2024, month, 0).getDate()
}

export const AnchorDateSelector = ({
  day,
  month,
  error,
  onUpdate,
}: {
  day: number
  month: number
  error?: Error
  onUpdate: (day?: number, month?: number) => any
}) => {
  const dayOptions = useMemo(() => {
    const daysInMonth = getDaysInMonth(month)
    return numericRangeOptions(1, daysInMonth)
  }, [month])

  useEffect(() => {
    const daysInMonth = getDaysInMonth(month)
    if (day > daysInMonth) {
      onUpdate(daysInMonth, month)
    }
  }, [month, day, onUpdate])

  const handleMonthChange = useCallback(
    (newMonth: number) => {
      const daysInMonth = getDaysInMonth(newMonth)
      const newDay = day > daysInMonth ? daysInMonth : day
      onUpdate(newDay, newMonth)
    },
    [day, onUpdate]
  )

  const handleDayChange = useCallback(
    (newDay: number) => {
      onUpdate(newDay, month)
    },
    [month, onUpdate]
  )

  return (
    <InlineStack gap="200" blockAlign="start">
      <div style={{ flex: '2 1 0', minWidth: 0 }}>
        <MemoedNumericSelect
          label=""
          labelHidden={true}
          options={monthOptions}
          value={month}
          onChange={handleMonthChange}
          error={error}
        />
      </div>
      <div style={{ flex: '1 1 0', minWidth: '70px' }}>
        <MemoedNumericSelect
          label=""
          labelHidden={true}
          options={dayOptions}
          value={day}
          onChange={handleDayChange}
        />
      </div>
    </InlineStack>
  )
}
